import { useState, useEffect } from "react";
import { useTheme } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Analytics from "@/Analytics";
import {
    setToken,
    selectIsTokenInvalid,
    selectSubscription,
} from "@/auth/authSlice";
import { InitScreen } from "@/auth/StyledComponents";
import { setError } from "@/nav/navSlice";

export default function Auth() {
    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const invalidToken = useSelector(selectIsTokenInvalid);
    const subscription = useSelector(selectSubscription);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (invalidToken) {
            dispatch(
                setError({
                    message: "Invalid login token, please login again.",
                }),
            );
            navigate("/logout");
        }
    }, [invalidToken]);

    useEffect(() => {
        Analytics.trackUserInfo({ subscription });
    }, [subscription]);

    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            dispatch(setToken(token));
        }
        // Slight delay since updating local state will hide the InitScreen and show the login screen
        // before redux triggers the app to show your desired logged-in page
        setTimeout(() => {
            setLoaded(true);
        }, 100);
    }, []);

    return loaded ? null : (
        <InitScreen backgroundColor={theme.palette.background.default}>
            <CircularProgress color="primary" sx={{ marginTop: "12px" }} />
        </InitScreen>
    );
}
